import { useMutation } from '@apollo/client'
import {
  DecisionEditPageUpdateRequestInput,
  UPDATE_DECISION_EDIT_PAGE_LINES,
  UpdateDecisionEditPageLinesResponse,
} from 'queries/mutations/update-decision-edit-page-lines'

export const useUpdateDecisionEditPageLines = () => {
  const [updateDecisionEditPageLines, { loading }] = useMutation<
    UpdateDecisionEditPageLinesResponse,
    DecisionEditPageUpdateRequestInput
  >(UPDATE_DECISION_EDIT_PAGE_LINES, {
    fetchPolicy: 'no-cache',
  })

  return { updateDecisionEditPageLines, loading }
}
